import React from "react";
import cn from "classnames";
import { WidthContainer } from "~components";
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from "./styles.module.scss";

const SliceConfig = ({ children, config }) => {
  const {
    background,
    backgroundColor,
    backgroundImage,
    textColor,
    padding = `regular`,
    reducePaddingBottom,
    reducePaddingTop
  } = config || {};

  return (
    <div
      className={styles.container}
      style={{
        color: textColor?.hex || `var(--color-classic-black)`,
        backgroundColor: backgroundColor?.hex || `var(--color-white)`
      }}
    >
      {background === `image` && backgroundImage && (
        <>
          <GatsbyImage
            image={backgroundImage.asset.gatsbyImageData}
            alt=""
            style={{
              position: `absolute`,
              inset: 0
            }}
          />
          <div className={styles.contrastOverlay} />
        </>
      )}

      <WidthContainer>
        <div
          className={cn(styles.content, {
            [styles.paddingRegular]: padding === `regular`,
            [styles.paddingLarge]: padding === `large`,
            [styles.reducePaddingBottom]: reducePaddingBottom,
            [styles.reducePaddingTop]: reducePaddingTop
          })}
        >
          {children}
        </div>
      </WidthContainer>
    </div>
  );
};

export default SliceConfig;
